import {TariffsInterface} from "./Tariffs.interface";

export const TariffsSchema: TariffsInterface = {
    discounts: {},
    services: [],
    tariffs: [],
}
